import {
  ActionReducer,
  ActionReducerMap,
  combineReducers,
  MetaReducer
} from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { maquinaInformeReducer } from 'src/app/mapa/store/reporte.reducer';
import { maquinaReducer } from 'src/app/maquinas/store/maquina.reducer';
import { localidadReducer } from 'src/app/usuarios/store/localidad/localidad.reducer';
import { usuarioReducer } from 'src/app/usuarios/store/usuario/usuario.reducer';
import { environment } from 'src/environments/environment';
import { IAppState } from './root/app.state';
export const actionReducer: ActionReducerMap<any> = {
  maquinas: maquinaReducer,
  localidades: localidadReducer,
  currentMaquina: maquinaInformeReducer,
  usuario: usuarioReducer,
};

export const rootReducers = combineReducers({
  maquinas: maquinaReducer,
  localidades: localidadReducer,
  currentMaquina: maquinaInformeReducer,
  usuario: usuarioReducer,
});

const reducerKeys = ['maquinas', 'localidades', 'currentMaquina'];
export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({ keys: reducerKeys, rehydrate: true })(reducer);
}

// console.log all actions
export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<IAppState>[] = !environment.production
  ? [debug, localStorageSyncReducer]
  : [localStorageSyncReducer];

// export function logout(reducer: ActionReducer<IAppState>): ActionReducer<IAppState> {
//   return (state, action) => {
//     if (action != null && action.type === UserActions.logout.type) {
//       return reducer(undefined, { type: INIT });
//     }
//     return reducer(state, action);
//   };
// }

// export const rootMetaReducers: MetaReducer<any>[] = [logout];
